import { render } from "./partnerDetails.vue?vue&type=template&id=513b56e9&scoped=true"
import script from "./partnerDetails.vue?vue&type=script&lang=js"
export * from "./partnerDetails.vue?vue&type=script&lang=js"

import "./partnerDetails.vue?vue&type=style&index=0&id=513b56e9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-513b56e9"]])

export default __exports__